import { PeriodFilter } from '../../types/models/period/period'

export const transformOtoIndividualEnrollmentsFiltersToUrl = (filters?: PeriodFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.year) searchParams.set('year', filters.year.toString())

  return searchParams.toString()
}

export const transformUrlToOtoIndividualEnrollmentsFilters = (
  searchParams: URLSearchParams
): PeriodFilter => {
  const filters: PeriodFilter = {}

  const year = searchParams.get('year')
  if (year) filters.year = +year

  return filters
}
